import React, { Fragment } from 'react'
import { shape, string, bool } from 'prop-types'

const LOGIN_COPY_GEORGE = 'Use your George, Asda Groceries, or Scan & Go sign in details'

const WelcomeMsg = ({ user, ui, login }) => {
  const { firstname, email, isUserActive } = user
  const { isThirdParty, isGeorgeUser, isCreditCardUser } = ui
  const { isPerimeterXEnabled } = login

  const ActiveThirdParty = () => (
    <div>
      <h1>Hi {firstname}</h1>
      <h4>Do you want to log in with this account</h4>
      <h3>{email}</h3>
      <br />
    </div>
  )

  const intractiveThirdPartyDesc = isCreditCardUser ? (
    <React.Fragment>
      <p>Please enter your Asda login details to continue your application.</p>
      <p>If you haven&apos;t got your account, you can register for one below.</p>
    </React.Fragment>)
    : <p>Enter your Asda login details, or register for a new Asda account.</p>
  const InactiveThirdParty = () => (
    <div>
      <h1>
        {isCreditCardUser ? 'Sign in to your Asda account' : 'Please sign in to Asda'}
      </h1>
      {isPerimeterXEnabled ?
      null : intractiveThirdPartyDesc}
    </div>
  )

  const ActiveUser = () => {
    if (email) {
      return (
        <div>
          <h1>Welcome back {firstname}</h1>
          <h3>Sign in </h3>
          { isGeorgeUser ? <p>{ LOGIN_COPY_GEORGE }</p> : null }
        </div>
      )
    }

    return (
      <Fragment>
        <h1>Sign in </h1>
        { isGeorgeUser ? <p>{ LOGIN_COPY_GEORGE }</p> : null }
      </Fragment>
    )
  }
  if (isThirdParty && isUserActive) {
    return <ActiveThirdParty />
  } else if (isThirdParty) {
    return <InactiveThirdParty />
  }
  return <ActiveUser />
}

WelcomeMsg.propTypes = {
  user: shape({
    firstname: string,
    email: string,
    isUserActive: bool,
  }),
  ui: shape({
    isThirdParty: bool,
  }),
  login: shape({
    isPerimeterXEnabled: bool,
  }).isRequired,
}

WelcomeMsg.defaultProps = {
  user: {
    firstname: '',
    email: '',
    isUserActive: true,
  },
  ui: {
    isThirdParty: false,
  },
}

export default WelcomeMsg
